<div class="soft-card rounded mb-2 w-full">
  @if (isStorno(bewe)) {
    <div class="flex flex-row justify-between flex-nowrap center p-1 border-box gap-6">
      <div class="flex flex-col w-full">
        <div class="g custom-grid" [ngClass]="(bewelf?.bezeichnung1?.length || 0) < 1 && (bewelf?.bezeichnung2?.length || 0) < 1 && !bewelf?.menge ? 'mt-1 font-semibold' : 'text-sm color-light mb-1'">
          <div>
            <div>
              <div class="flex items-center gap-2">
                <span class="text-sm color-light">
                  {{ bewelf?.artikelnummer }}
                </span>
                <soft-serial-number-view
                  [productId]="bewelf?.idartstamm ?? bewe?.artehBean?.id"
                  [serialNumber]="bewelf?.seriennr ?? bewe?.seriennr"
                  [deliveryNoteId]="deliveryNoteId"
                  [beweLfId]="bewelf?.id ?? bewe?.id"
                  (serialNumberChange)="patchBewe(bewelf?.id ?? bewe?.id, $event)"
                  />
              </div>
              @if ((bewe?.files || []).length > 0) {
                <i
                  class="fa-regular fa-images info-icon"
                ></i>
              }
            </div>
            @if ((bewe?.files || []).length > 0) {
              <i class="fa-regular fa-images info-icon"></i>
            }
          </div>
          <div class="flex gap-1 items-center flex-grow text-ellipsis overflow-hidden whitespace-nowrap">
            @if ((bewe?.vermerk || '').length > 0) {
              <i class="fa-regular fa-note-sticky info-icon"></i>
            }
            <div class="text-ellipsis overflow-hidden opacity-70">{{ bewe?.vermerk }}</div>
          </div>
        </div>
        <span class="mt-1 font-semibold">{{ bewelf?.bezeichnung1 }}</span>
        @if (bewelf?.bezeichnung2) {
          <div class="text-sm color-light mt-1">{{ bewelf?.bezeichnung2 }}</div>
        }
        @if (bewelf?.bezeichnung3) {
          <div class="text-sm color-light mt-1">{{ bewelf?.bezeichnung3 }}</div>
        }
        @if (bewelf?.zeilentext) {
          <div
            [ngClass]="(bewelf?.bezeichnung1?.length ?? 0) < 1 && (bewelf?.bezeichnung2?.length ?? 0) < 1 && !bewelf?.artikelnummer ? 'mt-1 font-semibold' : 'color-light mt-1'">
            {{ bewelf?.zeilentext }}
          </div>
        }
      </div>
      <div class="flex justify-end items-end min-w-[4rem]">
        <div class="flex flex-row justify-end text-base font-semibold">
          {{ bewe.menge ?? 0 }} {{ bewe.artehBean?.arteh }}
        </div>
      </div>
    </div>
  }
  @if (isEmballage(bewe)) {
    <div class="flex flex-row justify-between flex-nowrap center p-1 border-box gap-6">
      <div class="flex flex-col">
        <div class="flex text-sm color-light mb-1">
          <div class="flex items-center gap-2">
            <span class="text-sm color-light">
              {{ bewe.emballageBean.emballage }}
            </span>
            <soft-serial-number-view
              [productId]="bewelf?.idartstamm ?? bewe?.emballageBean?.id"
              [serialNumber]="$safeNavigationMigration(bewelf?.seriennr)"
              [deliveryNoteId]="deliveryNoteId"
              [beweLfId]="bewelf?.id ?? bewe?.id"
              />
          </div>

          @if ((bewe.files?.length ?? 0) > 0) {
            <i class="fa-regular fa-images info-icon"></i>
          }
          <div class="flex gap-1 items-center flex-grow text-ellipsis overflow-hidden whitespace-nowrap">
            @if ((bewe?.vermerk || '').length > 0) {
              <i class="fa-regular fa-note-sticky info-icon"></i>
            }
            <div class="text-ellipsis overflow-hidden opacity-70">{{ bewe?.vermerk }}</div>
          </div>
        </div>
        <span class="mt-1 font-semibold">{{ bewe.emballageBean.bezeichnung  }}</span>
      </div>
      <div class="flex justify-end items-end min-w-[4rem]">
        <div class="flex flex-row justify-end text-base font-semibold">
          {{ bewe.menge ?? 0 }} EH
        </div>
      </div>
    </div>
  }
  @if (isVermerk(bewe)) {
    <div class="flex flex-row justify-between flex-nowrap center p-1 border-box">
      <div class="flex flex-col">
        <span class="mt-1 font-semibold">{{ bewe.vermerk  }}</span>
      </div>
    </div>
  }
  @if (isSearchItem(bewe)) {
    <div class="flex flex-row justify-between flex-nowrap center p-1 border-box gap-6">
      <div class="flex flex-col w-full">
        <div class="g custom-grid" [ngClass]="(bewelf?.bezeichnung1?.length || 0) < 1 && (bewelf?.bezeichnung2?.length || 0) < 1 && !bewelf?.menge ? 'mt-1 font-semibold' : 'text-sm color-light mb-1'">
          <div>
            <span class="text-sm color-light">{{ bewelf?.artikelnummer }}</span>
            @if ((bewe?.files || []).length > 0) {
              <i class="fa-regular fa-images info-icon"></i>
            }
          </div>
          <div class="flex gap-1 items-center flex-grow text-ellipsis overflow-hidden whitespace-nowrap">
            @if ((bewe?.vermerk || '').length > 0) {
              <i class="fa-regular fa-note-sticky info-icon"></i>
            }
            <div class="text-ellipsis overflow-hidden opacity-70">{{ bewe?.vermerk }}</div>
          </div>
        </div>
        <span class="mt-1 font-semibold">{{ bewelf?.bezeichnung1 }}</span>
        @if (bewelf?.bezeichnung2) {
          <div class="text-sm color-light mt-1">{{ bewelf?.bezeichnung2 }}</div>
        }
        @if (bewelf?.zeilentext) {
          <div
            [ngClass]="(bewelf?.bezeichnung1?.length ?? 0) < 1 && (bewelf?.bezeichnung2?.length ?? 0) < 1 && !bewelf?.artikelnummer ? 'mt-1 font-semibold' : 'color-light mt-1'">
            {{ bewelf?.zeilentext }}
          </div>
        }
      </div>
      <div class="flex justify-end items-end min-w-[4rem]">
        <div class="flex flex-row justify-end text-base font-semibold">
          {{ bewe.menge ?? 0 }} {{ bewe.artehBean?.arteh }}
        </div>
      </div>
    </div>
  }
  @if (isScanItem(bewe)) {
    <div class="flex flex-row justify-between flex-nowrap center p-1 border-box gap-6">
      <div class="flex flex-col w-full">
        <div class="g custom-grid" [ngClass]="(bewelf?.bezeichnung1?.length || 0) < 1 && (bewelf?.bezeichnung2?.length || 0) < 1 && !bewelf?.menge ? 'mt-1 font-semibold' : 'text-sm color-light mb-1'">
          <div>
            <div class="flex items-center gap-2">
              <span class="text-sm color-light">
                {{ bewe.itemScanBean.artikel?.nummer }}
              </span>
              <soft-serial-number-view
                [productId]="bewelf?.idartstamm ?? bewe?.itemScanBean?.artikel?.id"
                [serialNumber]="bewelf?.seriennr ?? bewe?.seriennr"
                [deliveryNoteId]="deliveryNoteId"
                [beweLfId]="bewelf?.id ?? bewe?.id"
                />
            </div>
            @if ((bewe?.files || []).length > 0) {
              <i class="fa-regular fa-images info-icon"></i>
            }
          </div>
          <div class="flex gap-1 items-center flex-grow text-ellipsis overflow-hidden whitespace-nowrap">
            @if ((bewe?.vermerk || '').length > 0) {
              <i class="fa-regular fa-note-sticky info-icon"></i>
            }
            <div class="text-ellipsis overflow-hidden opacity-70">{{ bewe?.vermerk }}</div>
          </div>
        </div>
        <span class="mt-1 font-semibold">{{ bewe.itemScanBean.artikel?.artbez1 }}</span>
        @if (bewe.itemScanBean.artikel?.artbez2) {
          <div class="text-sm color-light mt-1">{{  bewe.itemScanBean.artikel?.artbez2 }}</div>
        }
        @if (bewe.itemScanBean.artikel?.artbez3) {
          <div class="color-light mt-1">
            {{  bewe.itemScanBean.artikel?.artbez3 }}
          </div>
        }
      </div>
      <div class="flex justify-end items-end min-w-[4rem]">
        <div class="flex flex-row justify-end text-base font-semibold">
          {{ bewe.itemScanBean?.menge ?? 0 }} {{ bewe.itemScanBean?.einheit?.arteh }}
        </div>
      </div>
    </div>
  }
</div>
